import { getLinkHref } from 'shared/helpers/uri';
import { EngagementUnit } from '../../shared/types';
import { BlockOneshopUpdatingOptionsForm } from 'shared/api/client';
import { Link, TitleHtmlTag } from 'shared/types';
import { FormattedProps } from './types';

export default function propsFormatter(
  content: BlockOneshopUpdatingOptionsForm['content']
): FormattedProps {
  const minorProductsEngagementUnit: Record<string, EngagementUnit> = {};

  content.minor_products.products.forEach(product => {
    if (product.productId && product.engagementUnit) {
      minorProductsEngagementUnit[product.productId] =
        EngagementUnit[product.engagementUnit];
    }
  });

  return {
    title: {
      label: content.title.label ?? '',
      htmlTag: content.title.htmlTag
        ? (content.title.htmlTag as TitleHtmlTag)
        : undefined
    },
    majorProducts: {
      title: content.major_products.title ?? '',
      endingDateLabel: content.major_products.ending_date_label,
      products: content.major_products.products.map(product => ({
        productId: product.productId ?? '',
        engagementUnit: product.engagementUnit
          ? EngagementUnit[product.engagementUnit]
          : null
      }))
    },
    minorProductsTitle: {
      label: content.minor_products.title.label ?? '',
      htmlTag: content.minor_products.title.htmlTag
        ? (content.minor_products.title.htmlTag as TitleHtmlTag)
        : undefined
    },
    minorProductsEngagementUnit,
    alertBox: {
      status: content.alert_box.status,
      title: content.alert_box.title,
      content: content.alert_box.content,
      link: content.alert_box.cta?.link
        ? {
            label: content.alert_box.cta?.label ?? '',
            href: getLinkHref(content.alert_box.cta.link as Link)
          }
        : null
    },
    submitButton: {
      label: content.submit_button.label ?? '',
      link: getLinkHref(
        content.submit_button.link ? (content.submit_button.link as Link) : null
      )
    },
    previousButton: content.previous_button
      ? {
          label: content.previous_button.label ?? '',
          link: getLinkHref(
            content.previous_button.link
              ? (content.previous_button.link as Link)
              : null
          )
        }
      : null,
    redirectLinkToStart: getLinkHref(content.redirect_link_to_start as Link),
    apis: {
      crmManagementActsOfferSearch: {
        url: content.apis.crm_management_acts_offer_search.url,
        method: content.apis.crm_management_acts_offer_search.method
      }
    },
    saleDeviceId: content.sale_device_id
  };
}
